import { render, staticRenderFns } from "./recordForm.component.vue?vue&type=template&id=4907cd70&scoped=true&"
import script from "./recordForm.component.vue?vue&type=script&lang=js&"
export * from "./recordForm.component.vue?vue&type=script&lang=js&"
import style0 from "./recordForm.component.vue?vue&type=style&index=0&id=4907cd70&lang=scss&scoped=true&"
import style1 from "./recordForm.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4907cd70",
  null
  
)

export default component.exports